import { ISetAssignmentStudentList } from './../../models/action/assignment';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/assignment';
import { ISetAddAssignment, ISetDeleteAssignment } from '../../models/action/assignment';


const setAssignmentData = (newState: any, assignmentPageActionPayload: any  ) => {
    const assignmentPageAction = assignmentPageActionPayload?.AssignmentData ? assignmentPageActionPayload.AssignmentData[0] : null;
    newState.AssignmentData = {
        activityId: assignmentPageAction ? assignmentPageAction.activityId : '',
        abbreviation: assignmentPageAction ? assignmentPageAction.abbreviation : '',
        name: assignmentPageAction ? assignmentPageAction.name : '',
        description: assignmentPageAction ? assignmentPageAction.description : '',
        isCommon: assignmentPageAction?.isCommon ? 1 : 0,
        dateCriteria: assignmentPageAction ? assignmentPageAction.dateCriteria : 0,
        datePrerequisiteActivityHours: assignmentPageAction?.datePrerequisiteActivityHours ?? '',
        datePrerequisiteActivityId: assignmentPageAction?.datePrerequisiteActivityId ? [assignmentPageAction.datePrerequisiteActivityId] : '',
        prerequisiteActivityId: assignmentPageAction?.prerequisiteActivityId ?? '',
        completionType: assignmentPageAction?.completionType ?? 1,
        completionCriteria: assignmentPageAction?.completionCriteria,
        alwaysOnTop: assignmentPageAction?.alwaysOnTop,
        isPersonalActivity: assignmentPageAction?.isPersonalActivity,
        isUpcomingNotification: assignmentPageAction?.isUpcomingNotification,
        upcomingNotificationTime: assignmentPageAction?.upcomingNotificationTime,
        isSendNotification: assignmentPageAction?.isSendNotification,
        notificationTime: assignmentPageAction?.notificationTime,
        isActivityPrerequisite: assignmentPageAction?.isActivityPrerequisite,
        allowDownload: assignmentPageAction?.allowDownload,
        assignmentMaximumUploadCount: assignmentPageAction?.assignmentMaximumUploadCount ?? 5,
        assignmentMaximumFileSize: assignmentPageAction?.assignmentMaximumFileSize ?? 1024,
        taskDeadline: assignmentPageAction?.taskDeadLine,
        taskDeadlinetime: '',
        customProperty5: assignmentPageAction?.customProperty5,
        dateRange: '',
        fileInputKey: '',
        photoUploadKey: '',
        activityConditionalBeginDate: assignmentPageAction?.beginDate,
        activityConditionalEndDate: assignmentPageAction?.endDate,
        termWeekIds: assignmentPageAction?.termWeekIds,
        selectedActivityOwnersTagIds: assignmentPageAction?.selectedActivityOwnersTagIds,
        selectedActivityUnitsTagIds: assignmentPageAction?.selectedActivityUnitsTagIds,
        selectedClass: assignmentPageAction?.selectedClass,
        allUnits: assignmentPageAction?.allUnits,
        courseId: assignmentPageAction?.courseId,
        cardImgName: assignmentPageAction?.cardImgName,
        file: assignmentPageAction?.file && assignmentPageAction.file.length > 0 ? assignmentPageAction.file : null,
        deletedFilesId: [],
        learningOutcomeId: assignmentPageAction?.learningOutcomeId,
        allowDownloadAfterDeadline: assignmentPageAction?.allowDownloadAfterDeadline,
    };
}

const assignmentReducer = (state = GlobalState().assignment, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = {};
    if (action.type === Actions.actions.SET_GROUP_ID) {
        const payload = (action as unknown) as any;
        newState.groupId = payload.groupId;
    }
    if (action.type === Actions.actions.SET_ASSIGNMENT_DATA_DEFAULT) {
        newState.AssignmentData = {
            isUpdate: false,
            isCommon: 0,
            name: '',
            description: '',
            filterActivityView: 'criterionDate',
            dateRange: '',
            selectActivity: [],
            note: 0,
            allUnits: false,
            selectUnits: [],
            selectCondition: [],
            selectOwner: [],
            completionType: 1,
            alwaysOnTop: false,
            dateCriteria: 0,
            fileInputKey: '',
            selectedClass: [],
            allowDownload: false,
            activitytype: '1',
            selectWeek: [],
            termWeekIds: [],
            activityTime: 0,
            selectedActivityUnitsTagIds: [],
            selectedActivityOwnersTagIds: [],
            prerequisiteActivityId: '',
            datePrerequisiteActivityId: '',
            cardImgName: '',
            learningOutcomeId: null,

        };
    }
    if (action.type === Actions.actions.ADD_ASSIGMENT_SET_ACTIVITY) {
        const assignmentPageActionPayload = (action as unknown) as ISetAddAssignment;
        setAssignmentData(newState, assignmentPageActionPayload);
    } else if (action.type === Actions.actions.DELETE_ASSIGNMENT_SET_ACTIVITY) {
        const coursePageAction = (action as ISetDeleteAssignment);
        newState.assignment.deleteAssignmentStatus = coursePageAction.deleteAssignmentStatus;
    } else if (action.type === Actions.actions.SET_ASSIGNMENT_STUDENT_LIST) {
        const assignmentPageActionPayload = action as ISetAssignmentStudentList;
        const users = assignmentPageActionPayload?.users ?? [];
        const filters = assignmentPageActionPayload?.filters ?? {};

        if (action.spinnerId == 'added') {
            newState.assignedStudentDatas = {
                filters,
                users
            };
        } else {
            newState.removedStudentDatas = {
                filters,
                users
            };
        }


    }
    return Object.assign({}, state, newState);
};

export default assignmentReducer;
